import { render, staticRenderFns } from "./otaInstrodution.vue?vue&type=template&id=6e98c584&scoped=true"
import script from "./otaInstrodution.vue?vue&type=script&lang=js"
export * from "./otaInstrodution.vue?vue&type=script&lang=js"
import style0 from "./otaInstrodution.vue?vue&type=style&index=0&id=6e98c584&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e98c584",
  null
  
)

export default component.exports